// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"24":"80144264","71":"bf2bf4f0","249":"4a51acfb","791":"d7e35a17"}[chunkId] + ".js";
};